// eslint-disable-next-line @typescript-eslint/naming-convention
export enum CONNECTIVITY_STATUSES {
  OPEN = 'Open',
  CLOSED = 'Closed',
  READY = 'Ready',
  SLOW = 'Slow',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum HEALTH_ENDPOINTS {
  HTTP_CLIENT = 'httpServer',
  FIX = 'QEP_OMS',
  STREAMING_ORDERS = 'QEP_DCR',
  BLOTTER = 'MySQL',
  REFERENEC_DATA = 'referenceData',
  TRADERDB = 'TraderDB',
  INVENTORY = 'Inventory',
  MARKET_DATA = 'MarketDataService',
  ORDER_SUMMARY = 'OrderSummary',
  OPTION_ANALYTICS = 'OptionAnalyticsService',
  OPTIONS = 'Options',
  SYMBOL_SERVICE = 'SymbolService',
  SLEEP = 'Sleep',
}

export type ConnectivityStatus = Record<HEALTH_ENDPOINTS, CONNECTIVITY_STATUSES[]>;
